import React, { Component } from 'react';
import withRouter from 'react-router/withRouter';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash/get';
import extend from 'lodash/extend';
import FeatureFeed from '../../../components/feature_feed/feature_feed';
import Ad from '../../../components/ad/ad';
import NotFound from '../../../components/not_found_component/not_found_component';
import LoadingSpinner from '../../../components/loading_spinner/loading_spinner';
import Slug from '../../../components/slug/slug';
import VideoModule from '../../../components/video_module/video_module';
import AllFeed from '../../../components/all_feed/all_feed';
import { categoryAllFeedAllStoriesRendered } from '../../../../redux/action_creators/category/category_all_feed_action_creators';
import MoreStories from '../../../components/more-stories-component/more-stories-component';
import { canUseDOM } from 'exenv';
import axios from 'axios';

// eslint-disable-next-line react/prefer-stateless-function
class Category extends Component {
  constructor(props) {
    super(props);

    this.fcebChannels = [
      'co-design',
      'technology',
      'work-life',
      'impact',
      'recommender'
    ];

    this.state = {
      hasFCEB: this.fcebChannels.includes(
        this.props.location.pathname.replace('/', '')
      ),
      fcebArticles: null,
      fcebTags: null
    };
  }
  componentDidMount() {
    const adData = get(this.props, 'categoryPage.ads');
    const successfulPageLoad = get(this.props, 'status') !== 404;

    if (canUseDOM && adData !== undefined && successfulPageLoad) {
      // Update the data layer
      extend(window.digitalData.page.pageInfo, {
        adPath: `/4160/mv.fc/${adData.model.adzone}`
      });
    }

    if (this.state.hasFCEB) {
      axios
        .get(
          '//fc-api.fastcompany.com/api/v2/posts-tag-slugs/fastcompany/fast-company-executive-board'
        )
        .then(res => {
          if (res.data.posts.length > 0) {
            this.setState({
              fcebArticles: res.data.posts.slice(0, 4),
              fcebTags: res.data.tags
            });
          }
        });
    }
  }

  render() {
    if (
      this.props.categoryPage.error ||
      this.props.categoryFeaturedFeed.error ||
      this.props.status === 404
    ) {
      return (
        <section className="category-page">
          <article className="category-page__main--error-pg">
            <NotFound />
          </article>
        </section>
      );
    }

    if (this.props.categoryPage.isLoading) {
      return (
        <section className="category-page">
          <article className="category-page__main">
            <LoadingSpinner />
          </article>
        </section>
      );
    }
    const adData = get(this.props, 'categoryPage.ads');
    const combinedAdModel = extend(
      {},
      { baseConfig: get(adData, 'config.baseConfig') },
      { definitions: get(adData, 'config.definitions') },
      { model: get(adData, 'model') }
    );

    const config = get(this.props, 'config');
    const tag = get(this.props, 'categoryAllFeed.tag.name');
    const category = get(this.props, 'categoryFeaturedFeed.category.name', '');
    const categorySlug = get(
      this.props,
      'categoryFeaturedFeed.category.slug',
      ''
    );
    const description = tag
      ? get(this.props, 'categoryAllFeed.tag.description')
      : get(this.props, 'categoryFeaturedFeed.category.description');
    const page = get(this.props, 'match.params.page', false);
    const totalPages = get(this.props, 'categoryAllFeed.totalPages');
    const hrefOverride = tag
      ? `/${get(this.props, 'categoryFeaturedFeed.category.slug')}/${get(
          this.props,
          'categoryAllFeed.tag.slug'
        )}/`
      : '';
    const type = tag ? `category_tag` : `category`;
    let isLastPage = Number(page) === totalPages;

    if (!page) {
      if (totalPages === 1) {
        isLastPage = true;
      }
      return (
        <section className="category-page">
          {/* <Ad {...combinedAdModel} name="oop" slug={false} oop={true} /> */}
          {/*
            <div className="homepage-mobile__featured-covid">
              UPDATES: <a href="/section/coronavirus">COVID-19</a>
            </div>}
          */}

          <section className="page-title">
            <Slug
              slugName={tag ? `${category} : ${tag}` : category}
              className="category-page"
            />
            {description ? (
              <h3
                className="page-description"
                dangerouslySetInnerHTML={{ __html: description }}
              />
            ) : (
              ''
            )}
          </section>
          <FeatureFeed
            config={config}
            featuredFeed={this.props.categoryFeaturedFeed}
            promoBanner={this.props.categoryPromoBanner}
            scrollingModule={this.props.categoryScrollingModule}
            combinedAdModel={combinedAdModel}
            page="category"
            featuredSponsoredCard={this.props.featuredSponsoredCard}
            sectionPath={get(this.props, 'location.pathname', '')}
          />

          {get(this.props, 'categoryFeaturedFeed.top.length') >= 2 ? (
            <div className="category-page__ff-ad-container">
              <Ad
                {...combinedAdModel}
                name="flexiblebillboard_2"
                noLazyLoad={true}
              />
              <Ad
                {...combinedAdModel}
                name="mobilerectangle_1"
                noLazyLoad={true}
              />
            </div>
          ) : (
            ''
          )}

          <VideoModule
            config={config}
            type="category"
            data={this.props.categoryVideo}
            playerid="HliaKwd3"
            stories={this.props.categoryVideo.playlist}
          />

          {get(this.props, 'categoryVideo.playlist.length') ? (
            <div className="category-page__video-ad-container">
              <Ad {...combinedAdModel} name="flexiblebillboard_3" />
              <Ad {...combinedAdModel} name="mobilerectangle_2" />
            </div>
          ) : (
            ''
          )}

          <AllFeed
            config={config}
            adModel={combinedAdModel}
            stories={get(this.props, 'categoryAllFeed.posts')}
            allRendered={get(this.props, 'categoryAllFeed.allRendered')}
            updateAction={categoryAllFeedAllStoriesRendered}
            paginationEnabled={true}
            page={Number(get(this.props, 'match.params.page', '1')) + 1}
            section={categorySlug}
            type={type}
            hrefOverride={hrefOverride}
            isLastPage={isLastPage}
            titleOverride={`All ${
              tag ? `${category} : ${tag}` : category
            } Stories`}
          />

          {this.state.hasFCEB &&
            this.state.fcebArticles && (
              <div>
                <MoreStories
                  metadata={this.state.fcebArticles}
                  slugData={{
                    name: 'From the FC Executive Board',
                    slug: 'fast-company-executive-board'
                  }}
                  tags={this.state.fcebTags}
                  config={config}
                  noBottomBorder={true}
                  isPost={false}
                />
              </div>
            )}

          {get(this.props, 'categoryAllFeed.posts.length') ? (
            <div className="category-page__all-ad-container">
              <Ad {...combinedAdModel} name="flexiblebillboard_5" />
              <Ad {...combinedAdModel} name="mobileparallax_2" />
            </div>
          ) : (
            ''
          )}
        </section>
      );
    }

    return (
      <section className="category-page">
        <section className="page-title page-title--paginated">
          <Slug
            slugName={`${tag ? `${category} : ${tag}` : category}`}
            className="category-page"
          />
          {description ? (
            <h3 className="page-description">{description}</h3>
          ) : (
            ''
          )}
        </section>
        <AllFeed
          config={config}
          hasSlug={false}
          adModel={combinedAdModel}
          stories={get(this.props, 'categoryAllFeed.posts')}
          allRendered={get(this.props, 'categoryAllFeed.allRendered')}
          updateAction={categoryAllFeedAllStoriesRendered}
          paginationEnabled={true}
          page={Number(get(this.props, 'match.params.page', '1')) + 1}
          section={categorySlug}
          type={type}
          isLastPage={isLastPage}
          paginationPath={`${category}`}
          hrefOverride={hrefOverride}
        />

        {this.state.hasFCEB && (
          <div>
            <MoreStories
              metadata={this.state.fcebArticles}
              slugData={{
                name: 'From the FC Executive Board',
                slug: 'fast-company-executive-board'
              }}
              tags={this.state.fcebTags}
              config={config}
              noBottomBorder={true}
              isPost={false}
            />
          </div>
        )}

        {get(this.props, 'categoryAllFeed.posts.length') ? (
          <div className="category-page__all-ad-container">
            <Ad {...combinedAdModel} name="flexiblebillboard_5" />
            <Ad {...combinedAdModel} name="mobileparallax_2" />
          </div>
        ) : (
          ''
        )}
      </section>
    );
  }
}

function mapStateToProps(state = {}) {
  return {
    config: state.config || {},
    status: state.status.code,
    categoryFeaturedFeed: {
      source: get(state, 'categoryFeaturedFeed.source', ''),
      featured: get(state, 'categoryFeaturedFeed.featured', []),
      top: get(state, 'categoryFeaturedFeed.top', []),
      category: get(state, 'categoryFeaturedFeed.category', {}),
      error: get(state, 'categoryFeaturedFeed.error', false)
    },
    categoryVideo: {
      playlist: get(state, 'categoryVideo.data.playlist', []),
      title: get(state, 'categoryVideo.data.title', ''),
      feedid: get(state, 'categoryVideo.data.feedid', '')
    },
    categoryPage: get(state, 'categoryPage', {}),
    categoryScrollingModule: get(state, 'categoryScrollingModule.data', {}),
    categoryPromoBanner: get(state, 'categoryPromoBanner.data', {}),
    featuredSponsoredCard: get(state, 'featuredSponsoredCard.data', {}),
    categoryAllFeed: {
      allRendered: get(state, 'categoryAllFeed.data.allRendered', false),
      posts: get(state, 'categoryAllFeed.data.posts', []),
      totalPages: get(state, 'categoryAllFeed.data.totalPages', 0),
      totalPosts: get(state, 'categoryAllFeed.data.totalPosts', 0),
      tag: get(state, 'categoryAllFeed.data.tag')
    }
  };
}

Category.propTypes = {
  status: PropTypes.number.isRequired,
  categoryPage: PropTypes.shape({
    ads: PropTypes.object,
    isLoading: PropTypes.bool,
    error: PropTypes.bool,
    errorMessage: PropTypes.string
  }).isRequired,
  categoryFeaturedFeed: PropTypes.shape({
    source: PropTypes.string,
    featured: PropTypes.arrayOf(PropTypes.shape({})),
    top: PropTypes.arrayOf(PropTypes.shape({})),
    category: PropTypes.object,
    error: PropTypes.bool
  }).isRequired,
  categoryVideo: PropTypes.shape({
    playlist: PropTypes.arrayOf(PropTypes.shape({})),
    feedid: PropTypes.string,
    title: PropTypes.string
  }).isRequired,
  categoryScrollingModule: PropTypes.shape({}).isRequired,
  categoryPromoBanner: PropTypes.shape({}).isRequired,
  featuredSponsoredCard: PropTypes.shape({}).isRequired,
  categoryAllFeed: PropTypes.shape({
    posts: PropTypes.arrayOf(PropTypes.shape({})),
    allRendered: PropTypes.bool,
    totalPages: PropTypes.number,
    totalPosts: PropTypes.number,
    tag: PropTypes.shape({})
  }).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string
  }).isRequired
};

export default withRouter(connect(mapStateToProps)(Category));
